import Tutorial, { ChapterType, ExerciseScene } from 'Types/ExerciseData';
import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import timestamps from './level0.json';

const Level0: Tutorial = {
  level: 0,
  videoUrl: 'level-0.mp4',
  end: '6:36',
  sections: [
    {
      chapters: [
        {
          start: '0:0',
          title: 'The Piano',
          data: [ChapterType.Lecture],
        },
        {
          start: '0:12.2',
          title: 'Highest and Lowest Keys',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.PianoScene,
                {
                  transition: 'Dissolve',
                  textPromptPosition: 'Bottom',
                  objectives: [
                    {
                      text: 'Play the key furthest to the left on your piano.',
                      target: 'any',
                      //videoCompleteDestination: '0:18',
                    },
                    {
                      text: 'Play the key furthest to the right on your piano.',
                      target: 'any',
                      //videoCompleteDestination: '0:24.2',
                    },
                  ],
                },
              ],
              events: [],
            },
          ],
        },
      ],
    },
    {
      chapters: [
        {
          start: '0:26',
          title: 'Counting Beats',
          data: [ChapterType.Lecture],
        },
        {
          start: '0:56',
          title: 'Tempo',
          data: [ChapterType.Lecture],
        },
        {
          start: '1:26',
          title: 'Playing Beats in Time',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.ExerciseTempoPractice,
                {
                  objectives: [
                    {
                      numBeats: 8,
                      tempo: 72,
                      text: 'Use any key to tap out 8 beats in sync with the tempo.',
                    },
                    {
                      numBeats: 8,
                      tempo: 120,
                      text: 'Use any key to tap out 8 beats in sync with the tempo.',
                    },
                  ],
                },
              ],
              events: [],
            },
          ],
        },
      ],
    },
    {
      chapters: [
        {
          start: '1:44',
          title: 'Music Notes',
          data: [ChapterType.Lecture],
        },
        {
          start: '2:26',
          title: 'Quarter Notes',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoteSequenceExercise,
                {
                  paddingHorizontal: 100,
                  tempo: 60,
                  objectives: [
                    {
                      scale: 1.4,
                      text: 'Play four quarter notes in a row, using any key.',
                      notes: [
                        { length: 'quarter' },
                        { length: 'quarter' },
                        { length: 'quarter' },
                        { length: 'quarter' },
                      ],
                    },
                  ],
                },
              ],
              events: [],
            },
          ],
        },
        {
          start: '2:37',
          title: 'Half Notes',
          data: [ChapterType.Lecture],
        },
        {
          start: '2:49',
          title: 'Half Notes',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoteSequenceExercise,
                {
                  tempo: 60,
                  paddingHorizontal: 100,
                  objectives: [
                    {
                      scale: 1.4,
                      text: 'Play three half notes in a row, using any key.',
                      notes: [{ length: 'half' }, { length: 'half' }, { length: 'half' }],
                    },
                  ],
                },
              ],
              events: [],
            },
          ],
        },
        {
          start: '3:03',
          title: 'Whole Notes',
          data: [ChapterType.Lecture],
        },
        {
          start: '3:17',
          title: 'Whole Notes',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoteSequenceExercise,
                {
                  tempo: 60,
                  paddingHorizontal: 150,
                  objectives: [
                    {
                      scale: 1.4,
                      text: 'Play two whole notes in a row, using any key.',
                      notes: [{ length: 'whole' }, { length: 'whole' }],
                    },
                  ],
                },
              ],
              events: [],
            },
          ],
        },
      ],
    },
    {
      chapters: [
        {
          start: '3:26',
          title: 'The Metronome',
          data: [ChapterType.Lecture],
        },
        {
          start: '3:51',
          title: 'Combining Rhythms',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoteSequenceExercise,
                {
                  tempo: 72,
                  paddingHorizontal: 150,
                  objectives: [
                    {
                      scale: 0.8,
                      text: 'Use any key to play these notes in time with the metronome',
                      notes: [
                        { length: 'half' },
                        { length: 'half' },
                        { length: 'quarter' },
                        { length: 'quarter' },
                        { length: 'half' },
                      ],
                    },
                    {
                      scale: 0.8,
                      text: 'Use any key to play these notes in time with the metronome',
                      notes: [
                        { length: 'quarter' },
                        { length: 'quarter' },
                        { length: 'quarter' },
                        { length: 'quarter' },
                        { length: 'half' },
                        { length: 'half' },
                      ],
                    },
                    {
                      scale: 0.8,
                      text: 'Use any key to play these notes in time with the metronome',
                      notes: [
                        { length: 'quarter' },
                        { length: 'half' },
                        { length: 'quarter' },
                        { length: 'whole' },
                      ],
                    },
                  ],
                },
              ],
              events: [],
            },
          ],
        },
      ],
    },
    {
      chapters: [
        {
          start: '4:10',
          title: 'The Grand Staff',
          data: [ChapterType.Lecture],
        },
        {
          start: '5:13',
          title: 'Reading Notes on the Staff',
          data: [ChapterType.Lecture],
        },
        {
          start: '5:39',
          title: 'Counting Bars',
          data: [ChapterType.Lecture],
        },
        {
          start: '5:59',
          title: 'Time Signatures',
          data: [ChapterType.Lecture],
        },
      ],
    },
  ],
};

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level0);
